import React from 'react';

const ScreensContext = React.createContext({});

export const useParentContext = () => ({ ...React.useContext(ScreensContext) });

export const useLinkBasename = (link) =>
  React.useContext(ScreensContext).getLinkBasename(link);

export const useLinkBasenameWithRoot = (link) => {
  const { getLinkBasename, _basename } = React.useContext(ScreensContext);
  const to = getLinkBasename(link);
  return to ? `${_basename}/${to}` : `${_basename}`;
};

export const useNavigation = () => {
  return React.useContext(ScreensContext).navigation;
};

export const useAvailablePageIds = () => React.useContext(ScreensContext).ids;
export const useNoAccess = () => React.useContext(ScreensContext).NoAccess;

export const usePages = (
  mapPageToOptions,
  { allowDuplicatePermission = true, allowHidden = true } = {}
) => {
  let pages = React.useContext(ScreensContext).pages;
  const cache = {};

  pages = allowHidden ? pages : pages.filter((page) => !page.hidden);

  pages = allowDuplicatePermission
    ? pages
    : pages.filter(({ id }) => {
        if (cache.hasOwnProperty(id)) {
          return false;
        }

        cache[id] = true;
        return true;
      });

  return typeof mapPageToOptions === 'function'
    ? pages.map(mapPageToOptions)
    : pages;
};

export const ScreensProvider = ({
  children,
  navigation,
  pages,
  getLinkBasename,
  NoAccess,
  ids,
  _basename,
}) => (
  <ScreensContext.Provider
    value={{
      navigation,
      pages,
      NoAccess,
      getLinkBasename,
      ids,
      _basename,
    }}
  >
    {children}
  </ScreensContext.Provider>
);
